"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.number.constructor.js");

var _tooltip = _interopRequireDefault(require("element-ui/lib/tooltip"));

var _emitter = _interopRequireDefault(require("element-ui/lib/mixins/emitter"));

// import directive from 'element-ui/packages/tooltip/src/directive';
var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('label', {
    staticClass: "el-checkbox",
    "class": [_vm.border && _vm.checkboxSize ? 'el-checkbox--' + _vm.checkboxSize : '', {
      'is-disabled': _vm.isDisabled
    }, {
      'is-bordered': _vm.border
    }, {
      'is-checked': _vm.isChecked
    }],
    attrs: {
      "role": "checkbox",
      "aria-checked": _vm.indeterminate ? 'mixed' : _vm.isChecked,
      "aria-disabled": _vm.isDisabled,
      "id": _vm.id
    }
  }, [_c('span', {
    staticClass: "el-checkbox__input",
    "class": {
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.isChecked,
      'is-indeterminate': _vm.indeterminate,
      'is-focus': _vm.focus
    },
    attrs: {
      "aria-checked": "mixed"
    }
  }, [_c('span', {
    staticClass: "el-checkbox__inner",
    attrs: {}
  }), _vm._v(" "), _vm.trueLabel || _vm.falseLabel ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "el-checkbox__original",
    attrs: {
      "type": "checkbox",
      "aria-hidden": "true",
      "name": _vm.name,
      "disabled": _vm.isDisabled,
      "true-value": _vm.trueLabel,
      "false-value": _vm.falseLabel
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
    },
    on: {
      "change": [function ($event) {
        var $a = _vm.model,
            $el = $event.target,
            $c = $el.checked ? _vm.trueLabel : _vm.falseLabel;

        if (Array.isArray($a)) {
          var $v = null,
              $i = _vm._i($a, $v);

          if ($el.checked) {
            $i < 0 && (_vm.model = $a.concat([$v]));
          } else {
            $i > -1 && (_vm.model = $a.slice(0, $i).concat($a.slice($i + 1)));
          }
        } else {
          _vm.model = $c;
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "el-checkbox__original",
    attrs: {
      "type": "checkbox",
      "aria-hidden": "true",
      "disabled": _vm.isDisabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : _vm.model
    },
    on: {
      "change": [function ($event) {
        var $a = _vm.model,
            $el = $event.target,
            $c = $el.checked ? true : false;

        if (Array.isArray($a)) {
          var $v = _vm.label,
              $i = _vm._i($a, $v);

          if ($el.checked) {
            $i < 0 && (_vm.model = $a.concat([$v]));
          } else {
            $i > -1 && (_vm.model = $a.slice(0, $i).concat($a.slice($i + 1)));
          }
        } else {
          _vm.model = $c;
        }
      }, _vm.handleChange],
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      }
    }
  })]), _vm._v(" "), _vm.hasOverflowTooltip && (_vm.$slots["default"] || _vm.label) ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.overflow",
      modifiers: {
        "overflow": true
      }
    }],
    staticClass: "el-checkbox__label",
    attrs: {}
  }, [_vm._t("default", null, {}), _vm._v(" "), !_vm.$slots["default"] ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm.$slots["default"] || _vm.label ? _c('span', {
    staticClass: "el-checkbox__label",
    attrs: {}
  }, [_vm._t("default", null, {}), _vm._v(" "), !_vm.$slots["default"] ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElCheckbox',
  mixins: [_emitter["default"]],
  inject: {
    elForm: {
      "default": ''
    },
    elFormItem: {
      "default": ''
    }
  },

  /** 扩展 */
  directives: {
    tooltip: _tooltip["default"].directive
  },

  /** */
  components: {// ElTooltip
  },
  componentName: 'ElCheckbox',
  data: function data() {
    return {
      selfModel: false,
      focus: false,
      isLimitExceeded: false
    };
  },
  computed: {
    model: {
      get: function get() {
        return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
      },
      set: function set(val) {
        if (this.isGroup) {
          this.isLimitExceeded = false;
          this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);
          this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);
          this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
        } else {
          this.$emit('input', val);
          this.selfModel = val;
        }
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    isChecked: function isChecked() {
      if ({}.toString.call(this.model) === '[object Boolean]') {
        return this.model;
      } else if (Array.isArray(this.model)) {
        return this.model.indexOf(this.label) > -1;
      } else if (this.model !== null && this.model !== undefined) {
        return this.model === this.trueLabel;
      }
    },
    isGroup: function isGroup() {
      var parent = this.$parent;

      while (parent) {
        if (parent.$options.componentName !== 'ElCheckboxGroup') {
          parent = parent.$parent;
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this._checkboxGroup = parent;
          return true;
        }
      }

      return false;
    },
    store: function store() {
      return this._checkboxGroup ? this._checkboxGroup.value : this.value;
    },
    isDisabled: function isDisabled() {
      return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
    },
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    checkboxSize: function checkboxSize() {
      var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
      return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
    },

    /** 扩展 */
    hasOverflowTooltip: function hasOverflowTooltip() {
      return this.isGroup ? this._checkboxGroup.overflowTooltip || this.overflowTooltip || (this.elForm || {}).overflowTooltip : this.overflowTooltip || (this.elForm || {}).overflowTooltip;
    }
    /** */

  },
  props: {
    value: {},
    label: {},
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: String,
    trueLabel: [String, Number],
    falseLabel: [String, Number],
    id: [String, Number]
    /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系 */
    ,
    controls: String
    /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系 */
    ,
    border: Boolean,
    size: String,

    /** 扩展 */
    overflowTooltip: Boolean
    /** */

  },
  methods: {
    addToStore: function addToStore() {
      if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
        this.model.push(this.label);
      } else {
        this.model = this.trueLabel || true;
      }
    },
    handleChange: function handleChange(ev) {
      var _this = this;

      if (this.isLimitExceeded) return;
      var value;

      if (ev.target.checked) {
        value = this.trueLabel === undefined ? true : this.trueLabel;
      } else {
        value = this.falseLabel === undefined ? false : this.falseLabel;
      }

      this.$emit('change', value, ev);
      this.$nextTick(function () {
        if (_this.isGroup) {
          _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
        }
      });
    }
  },
  created: function created() {
    this.checked && this.addToStore();
  },
  mounted: function mounted() {
    // 为indeterminate元素 添加aria-controls 属性
    if (this.indeterminate) {
      this.$el.setAttribute('aria-controls', this.controls);
    }
  },
  watch: {
    value: function value(_value) {
      this.dispatch('ElFormItem', 'el.form.change', _value);
    }
  }
};
exports["default"] = _default;